import { render, staticRenderFns } from "./FreelancerMoreSection.htm?vue&type=template&id=78d2f95e&scoped=true&"
import script from "./FreelancerMoreSection.ts?vue&type=script&lang=js&"
export * from "./FreelancerMoreSection.ts?vue&type=script&lang=js&"
import style0 from "./FreelancerMoreSection.scss?vue&type=style&index=0&id=78d2f95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2f95e",
  null
  
)

export default component.exports